// src/pages/HelpCategoryPage.jsx
import React from "react";
import { useParams } from "react-router-dom";

const helpData = {
  health: {
    headline: "Health",
    subheadline:
      "We connect women around the world to trusted health and wellness support — physical, mental, and emotional.",
    options: [
      "Weight Loss & Nutrition",
      "Depression & Anxiety",
      "Women’s Clinics & OB-GYN",
      "Fertility & Pregnancy",
      "Menopause & Hormonal Health",
      "Mental Health & Therapy",
      "Disability & Accessibility",
      "Sexual & Reproductive Health",
      "Chronic Illness Management",
      "Health Insurance Guidance",
    ],
  },
  legal: {
    headline: "Legal",
    subheadline:
      "Get connected to trusted legal services — from family law to workplace rights — tailored for women.",
    options: [
      "Family Law & Custody",
      "Divorce Support",
      "Domestic Violence Protection",
      "Workplace Harassment",
      "Immigration & Asylum",
      "Inheritance & Property Rights",
      "Legal Aid & Low-Cost Services",
      "Cybercrime & Online Abuse",
      "Contract & Employment Issues",
      "Human Rights Advocacy",
    ],
  },
  education: {
    headline: "Education",
    subheadline:
      "Find access to learning, training, and scholarships designed for women at every stage of life.",
    options: [
      "Scholarships & Grants",
      "Digital Skills & Literacy",
      "Higher Education Guidance",
      "Adult Education",
      "Language Learning",
      "Women in STEM Support",
      "Professional Certifications",
      "Tutoring & Academic Support",
      "Study Abroad Programs",
      "Free Online Courses",
    ],
  },
  jobs: {
    headline: "Jobs",
    subheadline:
      "Find work, return to the workforce, or level up your career — with women-first job solutions.",
    options: [
      "Remote & Flexible Jobs",
      "Resume & Interview Coaching",
      "Return-to-Work Support",
      "Job Placement for Women",
      "Work-from-Home Opportunities",
      "Career Switch Guidance",
      "Women in Tech Opportunities",
      "Job Fairs & Listings",
      "Internships & Apprenticeships",
      "Workplace Rights & Support",
    ],
  },
  business: {
    headline: "Business",
    subheadline:
      "Empowering women-led startups and entrepreneurs with the tools to grow and thrive.",
    options: [
      "Starting a Business",
      "Freelancing Platforms",
      "Licensing & Compliance",
      "Home-Based Business Ideas",
      "Branding & Marketing",
      "Access to Funding",
      "Business Coaching",
      "Export & Trade Guidance",
      "E-commerce for Women",
      "Co-working Spaces",
    ],
  },
  finance: {
    headline: "Finance",
    subheadline:
      "Take control of your finances with tools and guidance designed to support women’s economic independence.",
    options: [
      "Budgeting & Saving",
      "Microloans for Women",
      "Women’s Banks & Wallets",
      "Credit Repair Support",
      "Business Grants",
      "Investment Education",
      "Crypto & Fintech Guidance",
      "Emergency Funds",
      "Financial Planning",
      "Insurance Advice",
    ],
  },
  housing: {
    headline: "Housing",
    subheadline:
      "Access safe, secure, and supportive housing options tailored for women and families.",
    options: [
      "Safe Housing for Women",
      "Rental Assistance",
      "Emergency Shelters",
      "Relocation Support",
      "Single-Mother Housing",
      "Senior Housing",
      "Co-living Options",
      "Legal Rights as Tenant",
      "Domestic Violence Housing",
      "Affordable Housing Programs",
    ],
  },
  family: {
    headline: "Family",
    subheadline:
      "Support for every stage of family life — from childcare to elder care.",
    options: [
      "Childcare Services",
      "Parenting Support",
      "Fertility & IVF",
      "Single Parenting",
      "Elder Care",
      "Special Needs Support",
      "Adoption & Foster Care",
      "Family Counseling",
      "Matrimonial Advice",
      "Widow & Orphan Assistance",
    ],
  },
  fashion: {
    headline: "Fashion",
    subheadline:
      "Celebrate your identity with access to fashion education, women-led brands, and creative empowerment.",
    options: [
      "Women-Led Fashion Brands",
      "Modest Fashion Styling",
      "Fashion Design Education",
      "Personal Styling",
      "E-commerce for Fashion",
      "Fashion Photography",
      "Influencer Opportunities",
      "Accessories & Jewelry",
      "Sewing & Tailoring",
      "Sustainable Fashion",
    ],
  },
  community: {
    headline: "Community",
    subheadline:
      "Find your tribe. Connect with supportive women through local events, groups, and resources.",
    options: [
      "Women’s Support Groups",
      "Local & Online Events",
      "Forums & Safe Spaces",
      "Volunteering Opportunities",
      "Leadership Programs",
      "Mentorship Circles",
      "Women’s Clubs",
      "Activism & Campaigns",
      "Refugee & Migrant Support",
      "Mental Health Peer Support",
    ],
  },
};
const HelpCategoryPage = () => {
  const { category } = useParams();
  const data = helpData[category];

  if (!data)
    return (
      <div className="p-12 text-center text-red-600 font-bold">
        Category not found.
      </div>
    );

  return (
    <>
      <section
        className="relative text-white min-h-[80vh] flex items-center justify-center overflow-hidden"
        style={{
          background:
            "linear-gradient(90deg,rgba(252, 53, 236, 1) 0%, rgba(237, 0, 170, 1) 100%)",
        }}
      >
        <div
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1616692474781-9ef0114c15b1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')",
          }}
        ></div>

        <div className="relative z-10 text-center px-4 sm:px-6 max-w-5xl">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight font-[Aeonik]">
         {data.headline}
          </h1>
          <p className="text-2xl text-white mb-8">{data.subheadline}</p>
        </div>
      </section>
      <section className="max-w-5xl mx-auto px-4 py-16">
        <h1 className="text-4xl font-bold mb-4 text-main-dark">
          {data.headline}
        </h1>
        <p className="text-xl text-text-color mb-8">{data.subheadline}</p>

        <form className="space-y-6 bg-white shadow-md p-8 rounded-lg">
          <div>
            <label className="block mb-2 font-semibold">Full Name</label>
            <input
              type="text"
              className="w-full border px-4 py-2 rounded-md"
              required
            />
          </div>

          <div>
            <label className="block mb-2 font-semibold">Email</label>
            <input
              type="email"
              className="w-full border px-4 py-2 rounded-md"
              required
            />
          </div>

          <div>
            <label className="block mb-2 font-semibold">Phone (Optional)</label>
            <input type="text" className="w-full border px-4 py-2 rounded-md" />
          </div>

          <div>
            <label className="block mb-2 font-semibold">Country</label>
            <select className="w-full border px-4 py-2 rounded-md">
              {/* Insert all 250 countries dynamically or via import */}
              <option>Pakistan</option>
              <option>USA</option>
              <option>UK</option>
              <option>Canada</option>
              <option>India</option>
              {/* etc */}
            </select>
          </div>

          <div>
            <label className="block mb-2 font-semibold">City</label>
            <input type="text" className="w-full border px-4 py-2 rounded-md" />
          </div>

          <div>
            <label className="block mb-2 font-semibold">
              What do you need help with?
            </label>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {data.options.map((item, idx) => (
                <label key={idx} className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    name="helpOptions"
                    value={item}
                    className="accent-main-green w-4 h-4"
                  />
                  <span className="text-[#ED00AA] text-lg">{item}</span>
                </label>
              ))}
            </div>
          </div>

          <div>
            <label className="block mb-2 font-semibold">
              Describe your issue in detail
            </label>
            <textarea
              className="w-full border px-4 py-2 rounded-md"
              rows="5"
              required
            ></textarea>
          </div>

          <button
            type="submit"
            className="bg-main-green text-white px-6 py-3 rounded-md font-semibold hover:bg-green-700 transition"
          >
            Submit Request
          </button>

          <p className="text-sm text-gray-500 mt-4">
            🔒 Your request is confidential and will be matched with trusted
            professionals. We respond within 48 hours where available.
          </p>
        </form>
      </section>
    </>
  );
};

export default HelpCategoryPage;
